import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useStore';
import { Box, IconButton, Stack } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import TeacherPostReviewListStore from './TeacherPostReviewListStore';
import { PostT } from 'types/shared/core/Post';

const PostReviewActions = observer(({ post }: { post: PostT }) => {
  const { approve, reject } = useStore<TeacherPostReviewListStore>(
    'TeacherPostReviewListStore',
  );

  return (
    <Box flex={1}>
      <Stack direction="row" spacing={0.5} justifyContent="flex-end">
        <IconButton
          color="error"
          sx={{ flex: '0 0 auto', ml: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            reject(post);
          }}
        >
          <BackHandOutlinedIcon />
        </IconButton>
        <IconButton
          color="primary"
          sx={{ flex: '0 0 auto', ml: 0 }}
          onClick={(e) => {
            e.stopPropagation();
            approve(post);
          }}
        >
          <DoneIcon />
        </IconButton>
      </Stack>
    </Box>
  );
});

export default PostReviewActions;
